<template>
  <div class="onboarding_page">
    <h2>Innan ni gör utskick</h2>
    <p>
      Skapa en utskickmall under
      <a href="/ml-templates" target="_blank">Mallar</a> och gör sedan utskick via
      <a href="/ml-sendout" target="_blank">Utskick</a>.
    </p>
    <div class="wizard_actions">
      <button
        class="btn_prev"
        @click="prev_page"
      >
        Föregående
      </button>
      <button
        class="btn_next"
        @click="next_page"
      >
        Nästa
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'onboarding_page9',
  props: ['onboarding_data'],
  methods: {
    next_page() {
      this.$emit('update_data', { sendout_info: true })
      this.$emit('next_page')
    },
    prev_page() {
      this.$emit('update_data', { sendout_info: true })
      this.$emit('prev_page')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/sass/components/forms/_memlist_wizard.scss";

</style>
